import clsx from 'clsx';
import PropTypes from 'prop-types';
import * as React from 'react';

import mergeClasses from '../../../utils/shallowMerge';
import defaultClasses from './InlineMessage.module.scss';

const typeOfMessage = {
  success: 'success',
  error: 'error',
  warning: 'warning',
  info: 'info',
  custom: 'custom',
};

const InlineMessage = ({
  type,
  message = '',
  customClasses,
  className = null
}) => {
  const styles = mergeClasses(defaultClasses, customClasses);
  const cssClass = typeOfMessage[type];
  return (
    <div
      className={clsx(
        styles.messageContainer,
        styles.messageFont,
        styles[cssClass],
        className,
      )}
    >
      <span>{message}</span>
    </div>
  );
};

InlineMessage.propTypes = {
  message: PropTypes.string,
  type: PropTypes.oneOf(Object.keys(typeOfMessage)),
  customClasses: PropTypes.shape({
    messageContainer: PropTypes.string,
    messageFont: PropTypes.string,
    error: PropTypes.string,
    success: PropTypes.string,
    custom: PropTypes.string,
  }),
  className: PropTypes.string,
};

export default InlineMessage;
